<section
  *ngIf="notice$ | async as notice"
  class="update-banner"
  data-pwa-update-banner
  [attr.data-pwa-confirming]="confirmingDiscard"
  dir="rtl"
  role="region"
  aria-label="به‌روزرسانی برنامه"
>
  <div class="update-copy" role="status" aria-live="polite">
    <strong>به‌روزرسانی برنامه</strong>
    <p>{{ notice.message }}</p>
  </div>

  <ng-container *ngIf="!confirmingDiscard; else discardConfirmation">
    <button
      type="button"
      class="update-button"
      [disabled]="notice.busy || notice.reloading"
      (click)="update()"
    >
      {{ notice.reloading ? 'در حال به‌روزرسانی…' : 'به‌روزرسانی برنامه' }}
    </button>
  </ng-container>

  <ng-template #discardConfirmation>
    <div class="discard-confirmation" role="group" aria-label="تأیید به‌روزرسانی">
      <p>با به‌روزرسانی، اطلاعات ذخیره‌نشده از بین می‌رود. ادامه می‌دهید؟</p>
      <div class="update-actions">
        <button
          type="button"
          class="keep-button"
          [disabled]="notice.reloading"
          (click)="confirmingDiscard = false"
        >
          برگرد و ذخیره کن
        </button>
        <button
          type="button"
          class="update-button"
          [disabled]="notice.busy || notice.reloading"
          (click)="discardAndUpdate()"
        >
          بدون ذخیره، به‌روزرسانی کن
        </button>
      </div>
    </div>
  </ng-template>
</section>
